(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.koke.view
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.view :as esg]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.module.chart-card :as chart-card]))

(defn koke-section
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name investment-at-cost-valuation noi occupancy debt-financing]}
        holding-ui-data]
    [section
     holding-name
     nil
     [:div
      [grid/row {}
       [grid/column {:span 6}
        [chart-card/view "Gross investment at cost & Valuation" investment-at-cost-valuation
         props]]
       [grid/column {:span 6}
        [chart-card/view "NOI" noi props]]]
      [grid/row {}
       [grid/column {:span 6}
        [chart-card/view "Physical occupancy" occupancy props]]
       [grid/column {:span 6}
        [chart-card/view "Debt Financing" debt-financing props]]]]]))

(defn koke
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name investment-at-cost-valuation noi occupancy debt-financing]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [koke-section props]]))

(defn property-esg
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name investment-at-cost-valuation noi occupancy debt-financing]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [koke-section props]
     [esg/esg-section holding-ui-data props]]))


(defn portfolio-esg
  [{:keys [holding-ui-data] :as props}]
  (let [{:keys [holding-name investment-at-cost-valuation noi occupancy debt-financing]}
        holding-ui-data]
    [:div
     {:id (str "holding-report-" (:report-id holding-ui-data))}
     [koke-section props]
     [esg/portfolio-esg-section holding-ui-data props]]))
